export default __webpack_public_path__ + "static/media/twitter.032995fb.png";